import { isCalendarDateLike } from '@wilson/utils';
import {
  SeriesRuleV2,
  SeriesRuleV2Frequency,
} from '../series-rule-v2/series-rule-v2';
import { SeriesRuleType } from '../series-rule/series-rule';
import { WeekDaysEnum } from '../services/weekDays';

export class CreateSeriesRuleV2 {
  id?: string;
  frequency = SeriesRuleV2Frequency.Weekly;
  interval = 1;

  constructor(
    public startDate: string,
    public endDate: string,
    public type: SeriesRuleType,
    public weekdays: WeekDaysEnum[],
    public name: string | null = null,
    public comment: string | null = null,
  ) {
    if (name === '') {
      this.name = null;
    }
    if (comment === '') {
      this.comment = null;
    }

    CreateSeriesRuleV2.validate(this);
  }

  static validate(data: CreateSeriesRuleV2): void {
    const errors = new Set<string>();

    if (data.startDate && !isCalendarDateLike(data.startDate)) {
      errors.add(
        `startDate must be a yyyy-MM-dd string (received: ${data.startDate})`,
      );
    }

    if (data.endDate && !isCalendarDateLike(data.endDate)) {
      errors.add(
        `endDate must be a yyyy-MM-dd string (received: ${data.endDate})`,
      );
    }

    if (errors.size > 0) {
      throw new Error(
        `CreateSeriesRuleV2 validation failed: ${Array.from(errors).join(', ')}`,
      );
    }
  }

  static fromSeriesRuleV2({
    id,
    startDate,
    endDate,
    type,
    weekdays,
    ...rest
  }: SeriesRuleV2): CreateSeriesRuleV2 {
    const createSeriesRule = new CreateSeriesRuleV2(
      startDate,
      endDate,
      type,
      weekdays,
    );

    Object.assign(createSeriesRule, { id, ...rest });

    return createSeriesRule;
  }
}
